<template>
  <main class="finish-page flex flex-col justify-center items-center min-h-[60vh] py-16 sm:py-24 px-4 sm:px-6">
    <section class="text-center max-w-[594px] mx-auto rounded-lg">
      <h1 class="font-barlow-condensed font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl leading-tight mb-8 sm:mb-10">
        Le jeu Petit Navire<br />
        est à présent terminé !
      </h1>
      <div class="finish-bleu-block">
        <p class="finish-bleu-text">
          Pour en savoir plus sur nos actualités, rendez-vous sur
          <a
            href="https://www.petitnavire.fr"
            target="_blank"
            rel="noopener noreferrer"
            class="finish-bleu-link"
          >petitnavire.fr</a>
        </p>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "FinishView",
};
</script>

<style scoped>
.finish-page {
  background-color: #0d2651;
  background-image: url("@/assets/images/fond-perdu.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.finish-bleu-block {
  display: inline-flex;
  max-width: 420px;
  min-height: 76px;
  transform: rotate(-2deg);
  padding: 10px 14px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: #2490be;
  border-radius: 8px;
}

.finish-bleu-text {
  color: #fff;
  text-align: center;
  font-family: "Barlow Condensed", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  margin: 0;
}

.finish-bleu-link {
  color: #feefc7;
  font-family: "Barlow Condensed", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
}

.finish-bleu-link:hover {
  opacity: 0.9;
}
</style>
